import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';

const RouteUploader = ({ rutas = [], onToast }) => {
    const { user } = useAuth();
    const [routeList, setRouteList] = useState(rutas);
    const [uploadModal, setUploadModal] = useState(false);
    const [uploadData, setUploadData] = useState({
        nombre: '',
        cluster: '',
        brazo: '',
        descripcion: '',
        archivo: null
    });
    const [dragActive, setDragActive] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [clustersReales, setClustersReales] = useState([]);
    const [loadingClusters, setLoadingClusters] = useState(false);

    // Brazos por cluster - esto se puede hacer dinámico después
    const brazosPorCluster = {
        'CLUSTER A1': ['BRAZO A1-1', 'BRAZO A1-2', 'BRAZO A1-3'],
        'CLUSTER A2': ['BRAZO A2-1', 'BRAZO A2-2'],
        'CLUSTER A3': ['BRAZO A3-1', 'BRAZO A3-2', 'BRAZO A3-3'],
        'CLUSTER A4': ['BRAZO A4-1', 'BRAZO A4-2'],
        'CLUSTER AGS1': ['BRAZO AGS1-1', 'BRAZO AGS1-2'],
        'CLUSTER AGS2': ['BRAZO AGS2-1', 'BRAZO AGS2-2'],
        'CLUSTER AGS3': ['BRAZO AGS3-1', 'BRAZO AGS3-2'],
    };

    useEffect(() => {
        setRouteList(rutas);
    }, [rutas]);

    const cargarClusters = async () => {
        console.log('Todas las claves en localStorage:', Object.keys(localStorage));
        console.log('control_campo_token:', localStorage.getItem('control_campo_token'));
        console.log('control_campo_user:', localStorage.getItem('control_campo_user'));
        console.log('Token from authService:', localStorage.getItem("control_campo_token"));  // ✅ Debug
        console.log('User from authService:', authService.getUser());    // ✅ Debug

        const token = localStorage.getItem("control_campo_token");  // ✅ Usar la función del servicio
        if (!token) {
            console.error('❌ NO HAY TOKEN - Sesión expirada');
            onToast('Sesión expirada. Por favor inicia sesión again.', 'error');
            return;
        }

        setLoadingClusters(true);
        try {
            const response = await fetch('/api/coordinator/clusters', {
                headers: {
                    'Authorization': `Bearer ${token}`  // ✅ Token verificado
                }
            });

            if (response.ok) {
                const data = await response.json();
                setClustersReales(data.clusters || []);
                console.log('Clusters cargados:', data.clusters);  // ✅ Debug
            } else {
                console.error('Error en respuesta:', response.status);
                onToast('Error al cargar clusters', 'error');
            }
        } catch (error) {
            console.error('Error cargando clusters:', error);
            onToast('Error de conexión al cargar clusters', 'error');
        } finally {
            setLoadingClusters(false);
        }
    };

    const openUploadModal = () => {
        setUploadModal(true);
        setUploadData({
            nombre: '',
            cluster: '',
            brazo: '',
            descripcion: '',
            archivo: null
        });
        // Cargar clusters reales desde la API
        cargarClusters();
    };

    const closeUploadModal = () => {
        setUploadModal(false);
        setUploadData({
            nombre: '',
            cluster: '',
            brazo: '',
            descripcion: '',
            archivo: null
        });
        setIsUploading(false);
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            validateAndSetFile(file);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            validateAndSetFile(file);
        }
    };

    const validateAndSetFile = (file) => {
        const validExtensions = ['.kmz', '.kml'];
        const fileName = file.name.toLowerCase();
        const isValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

        if (isValidExtension) {
            const maxSize = 50 * 1024 * 1024; // 50MB
            if (file.size > maxSize) {
                onToast('El archivo es demasiado grande. Máximo 50MB', 'error');
                return;
            }
            setUploadData(prev => ({ ...prev, archivo: file }));
        } else {
            onToast('Solo se permiten archivos KMZ o KML', 'error');
        }
    };

    const handleUpload = async () => {
        if (!uploadData.nombre || !uploadData.cluster || !uploadData.brazo || !uploadData.archivo) {
            onToast('Por favor completa todos los campos obligatorios', 'error');
            return;
        }

        setIsUploading(true);

        try {
            const formData = new FormData();
            formData.append('archivo', uploadData.archivo);
            formData.append('nombre', uploadData.nombre);
            formData.append('cluster', uploadData.cluster);
            formData.append('brazo', uploadData.brazo);
            formData.append('descripcion', uploadData.descripcion);
            formData.append('coordinatorId', user.id);
            formData.append('region', user.region);
            formData.append('distrito', user.distrito);

            const response = await fetch('/api/coordinator/upload-route', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: formData
            });

            if (response.ok) {
                const newRoute = await response.json();
                setRouteList(prev => [...prev, {
                    ...newRoute,
                    fechaSubida: new Date().toISOString(),
                    asignada: false,
                    tecnicoAsignado: null
                }]);
                onToast('Ruta subida exitosamente', 'success');
                closeUploadModal();
            } else {
                const errorData = await response.json();
                onToast(errorData.detail || 'Error al subir la ruta', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            onToast('Error de conexión. Verifica tu internet', 'error');
        } finally {
            setIsUploading(false);
        }
    };

    const deleteRoute = async (routeId) => {
        if (!window.confirm('¿Estás seguro de eliminar esta ruta? Esta acción no se puede deshacer.')) return;

        try {
            const response = await fetch(`/api/coordinator/route/${routeId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (response.ok) {
                setRouteList(prev => prev.filter(route => route.id !== routeId));
                onToast('Ruta eliminada exitosamente', 'success');
            } else {
                const errorData = await response.json();
                onToast(errorData.detail || 'Error al eliminar ruta', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            onToast('Error de conexión', 'error');
        }
    };

    // Usar clusters reales desde la API
    const availableClusters = clustersReales;
    const availableBrazos = uploadData.cluster ? brazosPorCluster[uploadData.cluster] || [] : [];

    return (
        <div className="route-uploader">
            <div className="section-header">
                <div className="header-left">
                    <h2>🗺️ Gestión de Rutas</h2>
                    <p>Sube y administra archivos KMZ para tus rutas</p>
                </div>
                <button className="btn btn-primary" onClick={openUploadModal}>
                    📁 Subir Nueva Ruta
                </button>
            </div>

            <div className="routes-grid">
                {routeList.map((route) => (
                    <div key={route.id} className="route-card">
                        <div className="route-header">
                            <div className="route-info">
                                <h3>{route.nombre}</h3>
                                <p className="route-description">{route.descripcion || 'Sin descripción'}</p>
                            </div>
                            <div className="route-status">
                                <span className={`status-badge ${route.asignada ? 'assigned' : 'available'}`}>
                                    {route.asignada ? '🔒 Asignada' : '🟢 Disponible'}
                                </span>
                            </div>
                        </div>

                        <div className="route-details">
                            <div className="detail-item">
                                <span className="detail-label">📍 Distrito:</span>
                                <span className="detail-value">{route.distrito}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">🎯 Cluster:</span>
                                <span className="detail-value">{route.cluster}</span>
                            </div>
                            {route.asignada && route.tecnicoAsignado && (
                                <div className="detail-item">
                                    <span className="detail-label">👨‍🔧 Técnico:</span>
                                    <span className="detail-value">{route.tecnicoAsignado}</span>
                                </div>
                            )}
                            <div className="detail-item">
                                <span className="detail-label">📅 Subida:</span>
                                <span className="detail-value">
                                    {new Date(route.fechaSubida).toLocaleDateString()}
                                </span>
                            </div>
                        </div>

                        <div className="route-actions">
                            <button
                                className="btn btn-secondary"
                                onClick={() => window.open(route.archivoUrl, '_blank')}
                            >
                                📥 Descargar
                            </button>
                            {!route.asignada && (
                                <button
                                    className="btn btn-danger"
                                    onClick={() => deleteRoute(route.id)}
                                >
                                    🗑️ Eliminar
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {routeList.length === 0 && (
                <div className="empty-state">
                    <div className="empty-icon">🗺️</div>
                    <h3>No hay rutas disponibles</h3>
                    <p>Sube tu primer archivo KMZ para comenzar</p>
                    <button className="btn btn-primary" onClick={openUploadModal}>
                        📁 Subir Primera Ruta
                    </button>
                </div>
            )}

            {/* Modal de Subida */}
            {uploadModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>📁 Subir Nueva Ruta</h3>
                            <button className="modal-close" onClick={closeUploadModal}>×</button>
                        </div>

                        <div className="modal-body">
                            <div className="coordinator-info">
                                <h4>👨‍💼 {user?.name}</h4>
                                <div className="territory-info">
                                    <span>🌎 {user?.region}</span>
                                    <span>📍 {user?.distrito}</span>
                                </div>
                            </div>

                            <div className="upload-form">
                                <div className="form-group">
                                    <label>📝 Nombre de la Ruta</label>
                                    <input
                                        type="text"
                                        value={uploadData.nombre}
                                        onChange={(e) => setUploadData({
                                            ...uploadData,
                                            nombre: e.target.value
                                        })}
                                        placeholder="Ej: Ruta Centro Comercial Plaza Norte"
                                        className="form-input"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>🎯 Cluster</label>
                                    <select
                                        value={uploadData.cluster}
                                        onChange={(e) => setUploadData({
                                            ...uploadData,
                                            cluster: e.target.value,
                                            brazo: '' // Reset brazo when cluster changes
                                        })}
                                        className="form-select"
                                        disabled={loadingClusters}
                                    >
                                        <option value="">Seleccionar cluster...</option>
                                        {loadingClusters ? (
                                            <option value="" disabled>Cargando clusters...</option>
                                        ) : (
                                            availableClusters.map(cluster => (
                                                <option key={cluster} value={cluster}>
                                                    {cluster}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                    {loadingClusters && (
                                        <small>Cargando clusters desde la base de datos...</small>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label>🔗 Brazo</label>
                                    <select
                                        value={uploadData.brazo}
                                        onChange={(e) => setUploadData({
                                            ...uploadData,
                                            brazo: e.target.value
                                        })}
                                        className="form-select"
                                        disabled={!uploadData.cluster}
                                    >
                                        <option value="">Seleccionar brazo...</option>
                                        {availableBrazos.map(brazo => (
                                            <option key={brazo} value={brazo}>
                                                {brazo}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>📄 Descripción (Opcional)</label>
                                    <textarea
                                        value={uploadData.descripcion}
                                        onChange={(e) => setUploadData({
                                            ...uploadData,
                                            descripcion: e.target.value
                                        })}
                                        placeholder="Descripción de la ruta..."
                                        className="form-textarea"
                                        rows="3"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>📁 Archivo KMZ/KML</label>
                                    <div
                                        className={`file-upload-area ${dragActive ? 'drag-active' : ''} ${uploadData.archivo ? 'has-file' : ''}`}
                                        onDragEnter={handleDrag}
                                        onDragLeave={handleDrag}
                                        onDragOver={handleDrag}
                                        onDrop={handleDrop}
                                    >
                                        <input
                                            type="file"
                                            accept=".kmz,.kml"
                                            onChange={handleFileChange}
                                            className="file-input"
                                            id="file-upload"
                                        />
                                        <label htmlFor="file-upload" className="file-upload-label">
                                            {uploadData.archivo ? (
                                                <div className="file-selected">
                                                    <div className="file-icon">📁</div>
                                                    <div className="file-info">
                                                        <div className="file-name">{uploadData.archivo.name}</div>
                                                        <div className="file-size">
                                                            {(uploadData.archivo.size / 1024 / 1024).toFixed(2)} MB
                                                        </div>
                                                    </div>
                                                    <div className="file-status">✅</div>
                                                </div>
                                            ) : (
                                                <div className="file-placeholder">
                                                    <div className="upload-icon">📤</div>
                                                    <div className="upload-text">
                                                        <strong>Arrastra tu archivo KMZ aquí</strong>
                                                        <p>o haz clic para seleccionar</p>
                                                    </div>
                                                </div>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                {uploadData.archivo && uploadData.cluster && uploadData.brazo && (
                                    <div className="upload-preview">
                                        <h5>📋 Resumen de Subida:</h5>
                                        <div className="preview-item">
                                            <strong>Archivo:</strong> {uploadData.archivo.name}
                                        </div>
                                        <div className="preview-item">
                                            <strong>Coordinador:</strong> {user?.name}
                                        </div>
                                        <div className="preview-item">
                                            <strong>Región:</strong> {user?.region}
                                        </div>
                                        <div className="preview-item">
                                            <strong>Distrito:</strong> {user?.distrito}
                                        </div>
                                        <div className="preview-item">
                                            <strong>Cluster:</strong> {uploadData.cluster}
                                        </div>
                                        <div className="preview-item">
                                            <strong>Brazo:</strong> {uploadData.brazo}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeUploadModal}>
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleUpload}
                                disabled={!uploadData.nombre || !uploadData.cluster || !uploadData.brazo || !uploadData.archivo || isUploading}
                            >
                                {isUploading ? '📤 Subiendo...' : '📤 Subir Ruta'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .route-uploader {
                    width: 100%;
                }

                .section-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 30px;
                }

                .header-left h2 {
                    margin: 0 0 5px 0;
                    color: #333;
                    font-size: 1.5rem;
                }

                .header-left p {
                    margin: 0;
                    color: #666;
                }

                .routes-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
                    gap: 20px;
                }

                .route-card {
                    background: white;
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.07);
                    border-left: 4px solid #007bff;
                    transition: transform 0.2s ease;
                }

                .route-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0,0,0,0.1);
                }

                .route-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 15px;
                }

                .route-info h3 {
                    margin: 0 0 5px 0;
                    color: #333;
                    font-size: 1.1rem;
                }

                .route-description {
                    margin: 0;
                    color: #666;
                    font-size: 0.9rem;
                }

                .status-badge {
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 0.8rem;
                    font-weight: 600;
                }

                .status-badge.available {
                    background: #d4edda;
                    color: #155724;
                }

                .status-badge.assigned {
                    background: #fff3cd;
                    color: #856404;
                }

                .route-details {
                    margin-bottom: 20px;
                    padding: 15px;
                    background: #f8f9fa;
                    border-radius: 8px;
                }

                .detail-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                }

                .detail-item:last-child {
                    margin-bottom: 0;
                }

                .detail-label {
                    font-weight: 600;
                    color: #555;
                }

                .detail-value {
                    color: #333;
                    font-weight: 500;
                }

                .route-actions {
                    display: flex;
                    gap: 10px;
                }

                .btn {
                    padding: 8px 16px;
                    border: none;
                    border-radius: 6px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    flex: 1;
                    font-size: 0.9rem;
                }

                .btn-primary {
                    background: #667eea;
                    color: white;
                }

                .btn-primary:hover {
                    background: #5a67d8;
                }

                .btn-secondary {
                    background: #6c757d;
                    color: white;
                }

                .btn-secondary:hover {
                    background: #5a6268;
                }

                .btn-danger {
                    background: #dc3545;
                    color: white;
                }

                .btn-danger:hover {
                    background: #c82333;
                }

                .empty-state {
                    text-align: center;
                    padding: 60px 20px;
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.07);
                }

                .empty-icon {
                    font-size: 4rem;
                    margin-bottom: 20px;
                }

                .empty-state h3 {
                    margin: 0 0 10px 0;
                    color: #333;
                }

                .empty-state p {
                    margin: 0 0 20px 0;
                    color: #666;
                }

                /* Modal Styles */
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }

                .modal-content {
                    background: white;
                    border-radius: 12px;
                    width: 90%;
                    max-width: 600px;
                    max-height: 90vh;
                    overflow-y: auto;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                }

                .modal-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px;
                    border-bottom: 1px solid #e9ecef;
                }

                .modal-header h3 {
                    margin: 0;
                    color: #333;
                }

                .modal-close {
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    cursor: pointer;
                    color: #666;
                    padding: 0;
                    width: 30px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .modal-close:hover {
                    color: #333;
                }

                .modal-body {
                    padding: 20px;
                }

                .coordinator-info {
                    background: #e7f3ff;
                    padding: 15px;
                    border-radius: 8px;
                    margin-bottom: 20px;
                    text-align: center;
                    border-left: 4px solid #007bff;
                }

                .coordinator-info h4 {
                    margin: 0 0 10px 0;
                    color: #333;
                }

                .territory-info {
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                    font-size: 0.9rem;
                    color: #555;
                    font-weight: 600;
                }

                .upload-form {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .form-group label {
                    font-weight: 600;
                    color: #333;
                }

                .form-input, .form-select, .form-textarea {
                    padding: 10px;
                    border: 2px solid #e9ecef;
                    border-radius: 6px;
                    font-size: 1rem;
                    transition: border-color 0.3s ease;
                }

                .form-input:focus, .form-select:focus, .form-textarea:focus {
                    outline: none;
                    border-color: #667eea;
                }

                .form-select:disabled {
                    background: #f8f9fa;
                    color: #6c757d;
                    cursor: not-allowed;
                }

                .form-textarea {
                    resize: vertical;
                    min-height: 80px;
                }

                .file-upload-area {
                    border: 2px dashed #dee2e6;
                    border-radius: 8px;
                    padding: 20px;
                    transition: all 0.3s ease;
                    cursor: pointer;
                }

                .file-upload-area:hover, .file-upload-area.drag-active {
                    border-color: #667eea;
                    background: #f8f9ff;
                }

                .file-upload-area.has-file {
                    border-color: #28a745;
                    background: #f8fff9;
                }

                .file-input {
                    display: none;
                }

                .file-upload-label {
                    display: block;
                    cursor: pointer;
                }

                .file-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    color: #666;
                }

                .upload-icon {
                    font-size: 3rem;
                }

                .upload-text {
                    text-align: center;
                }

                .upload-text p {
                    margin: 5px 0 0 0;
                    font-size: 0.9rem;
                    color: #999;
                }

                .file-selected {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 10px;
                    background: white;
                    border-radius: 6px;
                    border: 1px solid #28a745;
                }

                .file-icon {
                    font-size: 2rem;
                }

                .file-info {
                    flex: 1;
                }

                .file-name {
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 2px;
                }

                .file-size {
                    font-size: 0.85rem;
                    color: #666;
                }

                .file-status {
                    font-size: 1.5rem;
                }

                .upload-preview {
                    background: #e7f3ff;
                    padding: 15px;
                    border-radius: 8px;
                    border-left: 4px solid #007bff;
                }

                .upload-preview h5 {
                    margin: 0 0 10px 0;
                    color: #333;
                }

                .preview-item {
                    margin-bottom: 5px;
                    color: #333;
                }

                .modal-footer {
                    padding: 20px;
                    border-top: 1px solid #e9ecef;
                    display: flex;
                    gap: 10px;
                    justify-content: flex-end;
                }

                .btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .btn:disabled:hover {
                    transform: none;
                }

                @media (max-width: 768px) {
                    .section-header {
                        flex-direction: column;
                        gap: 15px;
                        align-items: stretch;
                    }

                    .routes-grid {
                        grid-template-columns: 1fr;
                    }

                    .route-actions {
                        flex-direction: column;
                    }

                    .modal-content {
                        width: 95%;
                        margin: 10px;
                    }

                    .modal-footer {
                        flex-direction: column;
                    }

                    .file-selected {
                        flex-direction: column;
                        text-align: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default RouteUploader;